import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DemoModalData } from '@main/dashboards/components/demo.modal/demo.modal.component.types';

@Component({
    selector: 'app-allow-notifications-modal',
    templateUrl: './allow-notifications-modal.component.html',
    styleUrls: ['./allow-notifications-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllowNotificationsModalComponent {
    constructor(public dialogRef: MatDialogRef<AllowNotificationsModalComponent, DemoModalData>) {}

    ok() {
        this.dialogRef.close();
    }
}
